export default __webpack_public_path__ + "static/media/profile_pic.64c7e24b.png";